var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[(_vm.needDownUrl)?_c('video',{attrs:{"src":_vm.downloadURLImg+_vm.$route.query.url,"controls":""}}):_c('video',{attrs:{"src":_vm.$route.query.url,"controls":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }